/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Relationships/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function Relationships({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Relationship/Relationships",
  isInvalid,
  onChange
  
}) {
let relationshipsValueData = fromData.useDataValue({ viewPath,
context: 'relationships',
})
let editRelationTypeValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation',
path: 'type',
})
let editRelationTypeIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_relation',
path: 'type',
validate: fromValidate.text,
required: true,
})
let editRelationTypeChangeData = fromData.useDataChange({ viewPath,
context: 'edit_relation',
path: 'type',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 maxWidth={180}
 data="relationships"
 from={relationshipsValueData}
 allowEmptyChoice={false}
 data="edit_relation.type"
 validate="/Data/validate.js text"
 invalid={!editRelationTypeIsValidData}
 required={true}
 value={editRelationTypeValueData}
 onChange={editRelationTypeChangeData}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}